import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';

export const useAuth = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Détermine si l'utilisateur est authentifié - simplification de la logique
  const isAuthenticated = !!localStorage.getItem('token');
  
  // Pas de requête automatique, on utilise juste le token pour déterminer l'état
  const userData = null;
  const isLoadingUser = false;

  const loginMutation = useMutation({
    mutationFn: (credentials) => authService.login(credentials),
    onSuccess: (data) => {
      // Stocker le token
      localStorage.setItem('token', data.token);
      
      // Invalider les requêtes pour forcer un rafraîchissement des données
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      
      // Rediriger vers le dashboard après connexion réussie
      navigate('/dashboard', { replace: true });
    },
  });

  const logoutMutation = useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      // Supprimer le token
      localStorage.removeItem('token');
      
      // Réinitialiser l'état de l'application
      queryClient.clear();
      
      // Rediriger vers la page de connexion
      navigate('/login');
    },
  });

  return {
    user: userData?.data?.user,
    isAuthenticated,
    isLoadingUser,
    login: loginMutation.mutateAsync,
    logout: logoutMutation.mutate,
    isLoggingIn: loginMutation.isPending,
    isLoggingOut: logoutMutation.isPending,
    loginError: loginMutation.error,
  };
};